
import ProductIds from '../api/productIds';
import ProductGuids from '../api/productGuids';
import { LogCategory, log } from '../api/logger';

import Localizer from '../format/localizer';

var HeaderType = require('./headerType');
var LicenseType = require('./licenseType');


export default {



    minPrice: function(guidList, state) {
        var min = 99999;
        for ( var i in guidList) {
            var guid = guidList[i];
            var product = this._guidToProduct(guid, state);
            if ( product !== null) {
                var price = this.buyPriceForGuid(guid, state);
                if ( min > price)
                    min = price;
            }
        }

        return min;
    },







    _productIdToGuidList(productId) {
        switch ( productId) {
            case ProductIds.hm3AllStakes:
            case ProductIds.hm3Freemium:
            case ProductIds.hm3Trial:
                return ProductGuids.purchaseBuyHm3All;
            case ProductIds.hm3SmallStakes:
                return ProductGuids.purchaseBuyHm3Small;
            case ProductIds.omahaAllStakes:
                return ProductGuids.purchaseBuyOm3All;
            case ProductIds.omahaFreemium:
            case ProductIds.omahaTrial:
            case ProductIds.omahaSmallStakes:
                return ProductGuids.purchaseBuyOm3Small;
        }
        return [];
    },
    _productIdToFirstGuid(productId,state) {
        var list = this._productIdToGuidList(productId);
        return this._productGuidListToFirstGuid(list, state);
    },

    idToBuyProductGuid(productId, state) {
        return this._productIdToFirstGuid(productId, state);
    },

    _productGuidListToFirstGuid(list, state) {
        for ( var guidIdx in list)
            for ( var i in state.products.storeProducts) {
                var p = state.products.storeProducts[i];
                if (p.storeProductId == list[guidIdx])
                    return list[guidIdx];
            }
        return null;
    },

    _productGuidListToAvailableGuidList(list, state) {
        var available = [];
        for ( var guidIdx in list)
            for ( var i in state.products.storeProducts) {
                var p = state.products.storeProducts[i];
                if (p.storeProductId == list[guidIdx])
                    available.push( list[guidIdx]);
            }
        return available;
    },
    
    // if we have this GUID, returns it, otherwise returns null
    _tryFindGuid(guid, state) {
        for ( var i in state.products.storeProducts) {
            var p = state.products.storeProducts[i];
            if (p.storeProductId == guid)
                return guid;
        }
        return null;
    },

    // in this case, for HM3 -> return Omaha All stakes, or for Omaha -> return HM3 All Stakes
    otherProductGuid(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        var productId = isHm3 ? ProductIds.omahaAllStakes : ProductIds.hm3AllStakes;
        return this._productIdToFirstGuid(productId, state);
    },

    // if <0, we don't have this product
    buyPriceFor(productId, state) {
        var guid = this._productIdToFirstGuid(productId, state);
        if ( guid != null)
            return this.buyPriceForGuid(guid, state);
        return -1;
    },
    // if <0, we don't have this product
    buyPriceNoDiscountsFor(productId, state) {
        var guid = this._productIdToFirstGuid(productId, state);
        if ( guid != null)
            return this.buyPriceNoDiscountsForGuid(guid, state);
        return -1;
    },

    upgradeLicensePrice(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        return this._upgradePriceFor((isHm3 ? ProductIds.hm3SmallStakes : ProductIds.omahaSmallStakes), state);
    },

    renewLicensePrice(state) {
        var guid = this.renewLicenseGuid(state);
        return guid !== null ? this.buyPriceForGuid(guid, state) : -1 ;
    },

    buyLicensePrice(lic, state) {
        var isHm3 = lic.headerType == HeaderType.Hm3;
        return this.buyPriceFor((isHm3 ? ProductIds.hm3AllStakes : ProductIds.omahaAllStakes), state);
    },


    upgradeLicenseGuid(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        var productId = (isHm3 ? ProductIds.hm3SmallStakes : ProductIds.omahaSmallStakes);
        return this._upgradePriceGuid(productId, state);
    },

    upgradeFromFreeOrTrialLicenseGuid(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        var productId = (isHm3 ? ProductIds.hm3AllStakes : ProductIds.omahaAllStakes);
        return this._productIdToFirstGuid(productId, state);
    },

    _upgradePriceGuid(productId, state) {
        var upgrade = [];
        if ( productId == ProductIds.hm3SmallStakes)
            upgrade = ProductGuids.purchaseUpgradeHm3Small;
        else if ( productId == ProductIds.omahaSmallStakes)
            upgrade = ProductGuids.purchaseUpgradeOm3Small;
        if ( upgrade.length > 0) {
            var guid = this._productGuidListToFirstGuid(upgrade, state);
            return guid;
        }
        return "";
    },

    _upgradePriceFor(productId, state) {
        var upgrade = [];
        if ( productId == ProductIds.hm3SmallStakes)
            upgrade = ProductGuids.purchaseUpgradeHm3Small;
        else if ( productId == ProductIds.omahaSmallStakes)
            upgrade = ProductGuids.purchaseUpgradeOm3Small;

        var price = 0;
        if ( upgrade.length > 0) {
            var guids = this._productGuidListToAvailableGuidList(upgrade, state);
            if ( guids.length > 0)
                price = this.buyPriceForGuid(guids[0], state);
            for (var i in guids) {
                var guid = guids[i];
                var cur = this.buyPriceForGuid(guid, state);
                if ( cur < price)
                    price = cur;
            }
        }
        if ( price < .01)
            // note: here, it's a "buy"
            price = this.buyPriceFor(productId, state);

        return price;
    },

    // just for testing
    dumpPriceInfo(state) {
        if ( !LogCategory.price.log)
            return;

        var productId = 0;
        var preTrial = false;

        var isHm3 = state.header == HeaderType.Hm3;

        switch ( state.license.state) {
            case LicenseType.NoLicense:
                preTrial = true; break;
            case LicenseType.Trial:
                productId = isHm3 ? ProductIds.hm3Trial : ProductIds.omahaTrial;
                break;
            case LicenseType.Freemium:
                productId = isHm3 ? ProductIds.hm3Freemium : ProductIds.omahaFreemium;
                break;
            case LicenseType.Maintenance:
                if ( state.license.fullLicense)
                    productId = isHm3 ? ProductIds.hm3AllStakes : ProductIds.omahaAllStakes;
                else
                    productId = isHm3 ? ProductIds.hm3SmallStakes : ProductIds.omahaSmallStakes;
                break;
            default:
                log(LogCategory.price,"fatal: invalid state" + state.license.state);
                break;
        }

        if ( preTrial)
            log(LogCategory.price,"license: " + (isHm3 ? "hm3 pretrial" : "omaha pretrial"));
        else
            switch (productId) {
                case ProductIds.hm3AllStakes:           log(LogCategory.price,"License: hm3 all stakes"); break;
                case ProductIds.hm3SmallStakes:         log(LogCategory.price,"License: hm3 small stakes"); break;
                case ProductIds.hm3Freemium:            log(LogCategory.price,"License: hm3 freemium"); break;
                case ProductIds.hm3Trial:               log(LogCategory.price,"License: hm3 trial"); break;

                case ProductIds.omahaAllStakes:         log(LogCategory.price,"License: omaha all stakes"); break;
                case ProductIds.omahaSmallStakes:       log(LogCategory.price,"License: omaha small stakes"); break;
                case ProductIds.omahaFreemium:          log(LogCategory.price,"License: omaha freemium"); break;
                case ProductIds.omahaTrial:             log(LogCategory.price,"License: omaha trial"); break;
                default: console.assert(false); break;
            }

        log(LogCategory.price,"buy: " + this.buyLicensePrice(state.license, state));
        log(LogCategory.price,"renew: " + this.renewLicensePrice(state) + " for " + this.renewLicenseGuid(state));
    },




    buyPriceForGuid(guid, state) {
        if ( guid == null)
            return -1;

        var prices = this.guidToPrices(guid, state);
        var sum = 0;
        if ( prices != null)
            for ( var p in prices)
                sum += prices[p];

        sum = parseFloat(sum);
        if ( sum > -0.001 && sum < 0.0001)
            // yes, javascript is this stupid -> it sometimes will convert to "-0.00"
            // things like this keep life interesting
            sum = 0;
        //console.log("buy price for " + guid + " - " + prices + " - " + sum);
        return sum;
    },
    buyPriceNoDiscountsForGuid(guid, state) {
        if ( guid == null)
            return -1;

        var prices = this.guidToPricesNoDiscounts(guid, state);
        var sum = 0;
        if ( prices != null)
            for ( var p in prices)
                sum += prices[p];

        sum = parseFloat(sum);
        if ( sum > -0.001 && sum < 0.0001)
        // yes, javascript is this stupid -> it sometimes will convert to "-0.00"
        // things like this keep life interesting
            sum = 0;
        //console.log("buy price for " + guid + " - " + prices + " - " + sum);
        return sum;
    },

    _guidToProduct(guid,state) {
        for ( var i in state.products.storeProducts) {
            var p = state.products.storeProducts[i];
            if (p.storeProductId == guid)
                return p;
        }
        return null;
    },
    _guidToHmAppsProduct(guid,state) {
        for ( var i in state.hmApps) {
            var p = state.hmApps[i];
            for ( var v in p.appVariants)
                if ( p.appVariants[v].appVariantId == guid)
                    return p.appVariants[v];
        }
        return null;
    },

    _discounts(state) {
        if ( state.products.discounts.length > 0) {
            return state.products.discounts;
        }
        return [];
    },

    guidToNames: function(guid, state) {
        var names = [];
        var product = this._guidToHmAppsProduct(guid, state);
        if ( product != null) {
            names = [ { name: product.name, description: null } ];
            return names;
        }

        product = this._guidToProduct(guid, state);
        if ( product == null)
            // normally, should never happen - this is just a failsafe
            return [ {name: "N/A", description: null } ];

        // note: show maintenance contracts last
        for (var i in product.storeProductVariants) {
            var sub = product.storeProductVariants[i];
            if ( ProductGuids.buyGuid.includes(sub.storeProductVariantId)) {
                var description = sub.description != "" ? sub.description : null;
                names.push({name: sub.name, description: description });
            }
        }
        for (var i in product.storeProductVariants) {
            var sub = product.storeProductVariants[i];
            if ( !ProductGuids.buyGuid.includes(sub.storeProductVariantId)) {
                var description = sub.description != "" ? sub.description : null;
                names.push({name: sub.name, description: description });
            }
        }

        var discounts = product.discounts;
        for ( var d in discounts)
            names.push( {name: discounts[d].name, description: null });
        discounts = this._discounts(state);
        for ( var d in discounts)
            names.push( {name: discounts[d].name, description: null });

        return names;
    },

    guidToPricesNoDiscounts: function(guid, state) {
        var prices = [];
        var product = this._guidToProduct(guid, state);
        if (product == null)
        // normally, should never happen - this is just a failsafe
            return [ -1 ];

        // note: show maintenance contracts last
        for (var i in product.storeProductVariants) {
            var sub = product.storeProductVariants[i];
            if ( ProductGuids.buyGuid.includes(sub.storeProductVariantId))
                prices.push(sub.price);
        }
        for (var i in product.storeProductVariants) {
            var sub = product.storeProductVariants[i];
            if ( !ProductGuids.buyGuid.includes(sub.storeProductVariantId))
                prices.push(sub.price);
        }

        return prices;
    },

    guidToPrices: function(guid, state) {
        var product = this._guidToHmAppsProduct(guid, state);
        if ( product != null) {
            prices = [ product.retailPrice ];
            return prices;
        }

        product = this._guidToProduct(guid, state);        
        if (product == null)
            // normally, should never happen - this is just a failsafe
            return [ -1 ];

        var prices = this.guidToPricesNoDiscounts(guid, state);
        var discounts = product.discounts;
        for ( var d in discounts)
            prices.push( -discounts[d].amount);
        discounts = this._discounts(state);
        for ( var d in discounts)
            prices.push( -discounts[d].amount);

        return prices;
    },



    _subProductPriceDescription: function (sub) {
        var price = parseFloat(sub.price);
        var isZero = price > -0.0001 && price < 0.0001;
        if ( isZero) {
            var str = this.prefixPeriodString(sub.recurringFrequency, sub.recurringPeriod);
            return Localizer.format(Localizer.keys.recurringPriceDescription, [str]);
        }
        return "";
    },

    _subProductPricePaymentDetails(guid, sub, isZero) {
        let hasRecurring = sub.recurringFrequency != null && sub.recurringPeriod != null;
        if ( !hasRecurring)
            return "";
        var nextPayment = new Date();
        var freq = sub.recurringFrequency;
        switch(sub.recurringPeriod){
            case "days":
                nextPayment.setDate(nextPayment.getDate() + freq);
                break;
            case "months":
                let curMonth = nextPayment.getMonth();
                curMonth += freq;
                if ( curMonth >= 12) {
                    curMonth -= 12;
                    nextPayment.setFullYear( nextPayment.getFullYear() + 1);
                }
                nextPayment.setMonth(curMonth);
                break;
            case "years":
                nextPayment.setFullYear( nextPayment.getFullYear() + freq);
                break;
        }
        var nextPaymentDateStr =
            nextPayment.toLocaleDateString("en-US", {month: 'short'}) + " " +
            nextPayment.toLocaleDateString("en-US", {day: 'numeric'}) + ", " +
            nextPayment.toLocaleDateString("en-US", {year: 'numeric'}) ;
        
        var recurringStr = this.prefixPeriodString(sub.recurringFrequency, sub.recurringPeriod);
        if ( this.isHmOrOmahaRenewal(guid))
            return Localizer.format(Localizer.keys.renewalRecurringSubscription,[sub.recurringPrice, recurringStr, nextPaymentDateStr]) + " ";

        if ( isZero) 
            return Localizer.format(Localizer.keys.recurringSubscription,[sub.recurringPrice, recurringStr, nextPaymentDateStr]) + " ";
        else
            return Localizer.format(Localizer.keys.positivePrice,[sub.recurringPrice, recurringStr, nextPaymentDateStr]) + " ";
    },

    // if "", print the price
    // if non "", print whatever is here
    guidToPriceDescriptions: function(guid, state) {
        var prices = [];
        var product = this._guidToHmAppsProduct(guid, state);
        if ( product != null) {
            prices = [ "" ];
            return prices;
        }

        product = this._guidToProduct(guid, state);
        if (product == null)
        // normally, should never happen - this is just a failsafe
            return [ "" ];

        // note: show maintenance contracts last
        for (var i in product.storeProductVariants) {
            var sub = product.storeProductVariants[i];
            if ( ProductGuids.buyGuid.includes(sub.storeProductVariantId))
                prices.push( this._subProductPriceDescription(sub) );
        }
        for (var i in product.storeProductVariants) {
            var sub = product.storeProductVariants[i];
            if ( !ProductGuids.buyGuid.includes(sub.storeProductVariantId))
                prices.push( this._subProductPriceDescription(sub));
        }

        var discounts = product.discounts;
        for ( var d in discounts)
            prices.push( "");
        discounts = this._discounts(state);
        for ( var d in discounts)
            prices.push( "");

        return prices;
    },

    _hmAppsPricePaymentDetails: function(guid, state) {
        var price = 0;
        var name = "";
        var freq = 1;
        var period = "years";
        var free = false;
        for ( var i in state.hmApps) {
            var s = state.hmApps[i];
            for ( var j in s.appVariants) {
                var v = s.appVariants[j];
                if ( v.appVariantId == guid) {
                    price = v.userPrice;
                    name = v.name;
                    freq = v.recurringFrequency;
                    period = v.recurringPeriod;
                    free = !v.isPaymentRequired;
                }
            }
        }
        if ( free)
            return Localizer.format(Localizer.keys.hmAppOrderSummaryFree, [name]);

        var str = this.periodString(freq, period);
        return Localizer.format(Localizer.keys.hmAppOrderSummary, [name, str, price]);
    },

    pricePaymentDetails: function(guid, state) {
        if ( this.isHmApps(guid))
            return this._hmAppsPricePaymentDetails(guid, state);

        var product = this._guidToProduct(guid, state);
        if (product == null)
            // normally, should never happen - this is just a failsafe
            return "" ;

        var prices = this.guidToPrices(guid,state);
        var sum = 0;
        for ( var i in prices)
            sum += prices[i];
        var isZero = sum > -0.0001 && sum < 0.0001;

        for (var i in product.storeProductVariants) {
            var sub = product.storeProductVariants[i];
            var subPaymentDetails = this._subProductPricePaymentDetails(guid, sub, isZero) ;
            if ( subPaymentDetails != "")
                return subPaymentDetails;
        }
        return "";
    },

    // for now, the NoteCaddy message
    asteriskPaymentDetails: function(guid, state) {
        if ( this.isHmApps(guid))
            return "";

        var product = this._guidToProduct(guid, state);
        if (product == null)
            // normally, should never happen - this is just a failsafe
            return "" ;

        for (var i in product.storeProductVariants) {
            var sub = product.storeProductVariants[i];
            if ( sub.storeProductVariantId == "75e4abdd-2364-11eb-8f0b-0242ac150002")
                return Localizer.format(Localizer.keys.asteriskNotecadyIncluded);
        }
        return "";
    },

    guidAllStakesPrice: function(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        return this._productIdToFirstGuid((isHm3 ? ProductIds.hm3AllStakes : ProductIds.omahaAllStakes), state);
    },
    guidSmallStakesPrice: function(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        return this._productIdToFirstGuid((isHm3 ? ProductIds.hm3SmallStakes : ProductIds.omahaSmallStakes), state);
    },
    guidBothAllStakesPrice: function(state) {
        var guid = this.purchaseBothAllGuid(state);
        return guid;
    },
    guidBothSmallStakesPrice: function(state) {
        var guid = this.purchaseBothSmallGuid(state);
        return guid;
    },
    guidComboAllStakesPrice: function(state) {
        var guid = this.purchaseBothAllGuidIncludeUpgradeAllCombo(state);
        return guid;
    },

    buyAllStakesPrice: function(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        return this.buyPriceFor((isHm3 ? ProductIds.hm3AllStakes : ProductIds.omahaAllStakes), state);
    },
    buySmallStakesPrice: function(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        return this.buyPriceFor((isHm3 ? ProductIds.hm3SmallStakes : ProductIds.omahaSmallStakes), state);
    },
    buyBothAllStakesPrice: function(state) {
        var guid = this.purchaseBothAllGuid(state);
        return this.buyPriceForGuid(guid, state);
    },
    buyBothSmallStakesPrice: function(state) {
        var guid = this.purchaseBothSmallGuid(state);
        return this.buyPriceForGuid(guid, state);
    },



    // only discounts that are not a refund count here (mla-182)
    guidHasDiscountOrRefund: function(guid, state) {
        if ( guid == null)
            return false;

        var product = this._guidToProduct(guid, state);
        if (product == null)
        // normally, should never happen - this is just a failsafe
            return false;

        var discounts = product.discounts;
        for ( var i in discounts) {
            var d = discounts[i];
            if (d.amount > 0.0001 && (d.type == "discount" || d.type == "refund"))
                return true;
        }
        discounts = this._discounts(state);
        for ( var i in discounts) {
            var d = discounts[i];
            if (d.amount > 0.0001 && (d.type == "discount" || d.type == "refund"))
                return true;
        }

        return false;
    },

    guidHasRefund: function(guid,state) {
        if ( guid == null)
            return false;

        var product = this._guidToProduct(guid, state);
        if (product == null)
        // normally, should never happen - this is just a failsafe
            return false;

        var discounts = product.discounts;
        for ( var i in discounts) {
            var d = discounts[i];
            if (d.amount > 0.0001 && (d.type == "refund"))
                return true;
        }
        discounts = this._discounts(state);
        for ( var i in discounts) {
            var d = discounts[i];
            if (d.amount > 0.0001 && (d.type == "refund"))
                return true;
        }

        return false;
    },

    // returns a valid expiry date as Date(), or null if no expiry found
    _guidDiscountExpires: function(guid, state) {
        var product = this._guidToProduct(guid, state);
        if ( product == null)
            return null;

        var discounts = product.discounts;
        for ( var i in discounts) {
            var d = discounts[i];
            if (d.amount > 0.0001 && (d.type == "discount" || d.type == "refund"))
                return new Date( Date.parse( d.expires));
        }
        return null;
    },

    // only discounts that are not a refund count here (mla-182)
    buyAllStakesHasDiscount: function(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        var guid = this._productIdToFirstGuid((isHm3 ? ProductIds.hm3AllStakes : ProductIds.omahaAllStakes), state);
        return this.guidHasDiscountOrRefund(guid, state);
    },
    // only discounts that are not a refund count here (mla-182)
    buySmallStakesHasDiscount: function(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        var guid = this._productIdToFirstGuid((isHm3 ? ProductIds.hm3SmallStakes : ProductIds.omahaSmallStakes), state);
        return this.guidHasDiscountOrRefund(guid, state);
    },
    // only discounts that are not a refund count here (mla-182)
    buyComboAllStakesHasDiscount: function(state) {
        var guid = this.purchaseBothAllGuidIncludeUpgradeAllCombo(state);
        return this.guidHasDiscountOrRefund(guid, state);
    },
    // only discounts that are not a refund count here (mla-182)
    buyBothSmallStakesHasDiscount: function(state) {
        var guid = this.purchaseBothSmallGuid(state);
        return this.guidHasDiscountOrRefund(guid, state);
    },
    buyHm3OrOmahaHasRefund: function(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        var guid = this._productIdToFirstGuid((isHm3 ? ProductIds.hm3AllStakes : ProductIds.omahaAllStakes), state);
        if ( guid != null)
            if ( this.guidHasRefund(guid,state))
                return true;
        guid = this._productIdToFirstGuid((isHm3 ? ProductIds.hm3SmallStakes : ProductIds.omahaSmallStakes), state);
        if ( guid != null)
            if ( this.guidHasRefund(guid,state))
                return true;
        guid = this.purchaseBothAllGuidIncludeUpgradeAllCombo(state);
        if ( guid != null)
            if ( this.guidHasRefund(guid,state))
                return true;
        guid = this.purchaseBothSmallGuid(state);
        if ( guid != null)
            if ( this.guidHasRefund(guid,state))
                return true;

        return false;
    },




    _buyAllStakesDiscountExpires: function(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        var guid = this._productIdToFirstGuid((isHm3 ? ProductIds.hm3AllStakes : ProductIds.omahaAllStakes), state);
        return this._guidDiscountExpires(guid, state);
    },
    _buySmallStakeDiscountExpires: function(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        var guid = this._productIdToFirstGuid((isHm3 ? ProductIds.hm3SmallStakes : ProductIds.omahaSmallStakes), state);
        return this._guidDiscountExpires(guid, state);
    },
    _buyBothAllStakesDiscountExpires: function(state) {
        var guid = this.purchaseBothAllGuid(state);
        return this._guidDiscountExpires(guid, state);
    },
    _buyBothSmallStakesDiscountExpires: function(state) {
        var guid = this.purchaseBothSmallGuid(state);
        return this._guidDiscountExpires(guid, state);
    },


    // if null, we can't upgrade
    upgradeToAllGuid: function(state) {
        let isHm3 = state.header == HeaderType.Hm3;
        if ( !state.license.fullLicense) {
            let guid = this._productGuidListToFirstGuid(isHm3 ? ProductGuids.purchaseUpgradeHm3Small : ProductGuids.purchaseUpgradeOm3Small, state);
            return guid;
        }
        return null;
    },

    // if null, we can't upgrade
    upgradeToComboSmallGuid: function(state) {
        let isHm3 = state.header == HeaderType.Hm3;
        if ( !state.license.fullLicense) {
            let guid = this._productGuidListToFirstGuid(isHm3 ? ProductGuids.upgradeHm3ToComboSmall : ProductGuids.upgradeOm3ToComboSmall, state);
            return guid;
        }
        return null;
    },
    // if null, we can't upgrade
    upgradeToComboAllGuid: function(state) {
        let isHm3 = state.header == HeaderType.Hm3;
        if ( !state.license.fullLicense) {
            let guid = this._productGuidListToFirstGuid(isHm3 ? ProductGuids.upgradeHm3ToComboAll : ProductGuids.upgradeOm3ToComboAll, state);
            return guid;
        }
        return null;
    },



    hasDiscounts: function (state) {
        return this.buyAllStakesHasDiscount(state) || this.buySmallStakesHasDiscount(state)
            || this.buyComboAllStakesHasDiscount(state) || this.buyBothSmallStakesHasDiscount(state);
    },

    discountExpiresDate: function(state) {
        var allStakes = this._buyAllStakesDiscountExpires(state);
        var smallStakes = this._buySmallStakeDiscountExpires(state);
        var bothAllStakes = this._buyBothAllStakesDiscountExpires(state);
        var bothSmallStakes = this._buyBothSmallStakesDiscountExpires(state);
        if ( allStakes != null)
            return allStakes;
        if ( smallStakes != null)
            return smallStakes;
        if ( bothAllStakes != null)
            return bothAllStakes;
        if ( bothSmallStakes != null)
            return bothSmallStakes;

        log(LogCategory.fatal, "Discount Expiry date not found");
        return new Date();
    },



    purchaseBothAllGuidIncludeUpgradeAllCombo(state) {
        return this._productGuidListToFirstGuid( ProductGuids.purchaseBothAllIncludeUpgradeAllCombo, state);
    },
    purchaseBothAllGuid(state) {
        return this._productGuidListToFirstGuid( ProductGuids.purchaseBothAll, state);
    },
    purchaseBothSmallGuid(state) {
        return this._productGuidListToFirstGuid( ProductGuids.purchaseBothSmall, state);
    },

    // if NO, that means the user has either HM3 All Stakes or OM3 All Stakes, thus he can only buy the other product (can't really buy a combo)
    canPurchaseBothAll(state) {
        return this._productGuidListToFirstGuid( ProductGuids.purchaseBothAll, state) != null;
    },
    // if NO, that means the user has either HM3 All Stakes or OM3 All Stakes, thus he can only buy the other product (can't really buy a combo)
    canPurchaseBothSmall(state) {
        return this._productGuidListToFirstGuid( ProductGuids.purchaseBothSmall, state) != null;
    },
    canPurchaseBothAllIncludeUpgradeAllCombo(state) {
        return this._productGuidListToFirstGuid( ProductGuids.purchaseBothAllIncludeUpgradeAllCombo, state) != null;
    },

    // if the other product already has a license (small or all) -> we can't purchase the other product (we could only upgrade it)
    canPurchaseOtherProduct(state) {
        var otherProductIsOmaha = state.header == HeaderType.Hm3;
        var otherProduct = otherProductIsOmaha ? state.licenseOmaha : state.licenseHm3;
        var hasLicense = otherProduct.state == LicenseType.Maintenance;
        return !hasLicense;
    },

    renewLicenseGuid(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        if ( isHm3) {
            let guid = this._productGuidListToFirstGuid(ProductGuids.renewHm3, state);
            return guid;
        }
        else {
            let guid = this._productGuidListToFirstGuid(ProductGuids.renewOm3, state);
            return guid;
        }
    },

    // returns true if it's an HM APPS purchase
    isHmApps(guid) {
        // range wizard
        if ( guid == "32fa0c52-e6e8-11ea-a903-0242ac170002")
            return true;
        if ( guid == "08222b30-e6e8-11ea-a903-0242ac170002")
            return true;

        // notecaddy
        if ( guid == "3c82b67d-22f8-11eb-9286-12aab952340b")
            return true;
        if ( guid == "7e11c5d3-22f7-11eb-9286-12aab952340b")
            return true;
        if ( guid == "87be1e6d-22f8-11eb-9286-12aab952340b")
            return true;
        if ( guid == "c79d6c42-22f8-11eb-9286-12aab952340b")
            return true;
        if ( guid == "e523341a-22fa-11eb-9286-12aab952340b")
            return true;

        return false;
    },

    isHmOrOmahaRenewal(guid) {
        return ProductGuids.renewals.includes(guid);
    },

    // returns true, if when on HM or Omaha "buy" page, we can only renew (as opposed to do an initial purchase or upgrade)
    isDoingRenewalHmOrOmaha(state) {
        var isHm3 = state.header == HeaderType.Hm3;
        let guid = this._productGuidListToFirstGuid(isHm3 ? ProductGuids.renewHm3 : ProductGuids.renewOm3 , state);
        return guid != null;
    },

    renewalHmOrOmahaText(state){
        var guid = this.renewLicenseGuid(state);
        var isHm3 = state.header == HeaderType.Hm3;
        if ( isHm3) {
            var isSmall = ProductGuids.renewHm3Small.includes(guid);
            return Localizer.format(isSmall ? Localizer.keys.buyHoldemSmallStakes : Localizer.keys.buyHoldemAllStakes) ;
        } else {
            var isSmall = ProductGuids.renewOm3Small.includes(guid);
            return Localizer.format(isSmall ? Localizer.keys.buyOmahaSmallStakes : Localizer.keys.buyOmahaAllStakes) ;
        }
    }, 

    isRenewalHmOrOmahaSmall(state) {
        var guid = this.renewLicenseGuid(state);
        var isHm3 = state.header == HeaderType.Hm3;
        if ( isHm3) {
            var isSmall = ProductGuids.renewHm3Small.includes(guid);
            return Localizer.format(isSmall ? Localizer.keys.buyHoldemSmallStakes : Localizer.keys.buyHoldemAllStakes) ;
        } else {
            var isSmall = ProductGuids.renewOm3Small.includes(guid);
            return Localizer.format(isSmall ? Localizer.keys.buyOmahaSmallStakes : Localizer.keys.buyOmahaAllStakes) ;
        }
    },

    renewalHmOrOmahaPrice(state) {
        var guid = this.renewLicenseGuid(state);
        return this.buyPriceForGuid(guid, state);
    },

    // recurringPeriod: "months", "years"
    periodString(recurringFrequency, recurringPeriod) {
        console.assert(recurringPeriod == "days" || recurringPeriod == "months" || recurringPeriod == "years");
        if ( recurringPeriod == "months" && recurringFrequency == 12) {
            recurringPeriod = "years";
            recurringFrequency = 1;
        }

        if ( recurringFrequency > 1)
            return Localizer.format( recurringPeriod == "days" ? Localizer.keys.dayPlural 
                : recurringPeriod == "months" ? Localizer.keys.monthPlural : Localizer.keys.yearPlural, [recurringFrequency] );
        else 
            return Localizer.format( recurringPeriod == "days" ? Localizer.keys.daySingle 
                : recurringPeriod == "months" ? Localizer.keys.monthSingle : Localizer.keys.yearSingle);
    },
    // even if single period, we'll still prefix it, like, "one year"
    prefixPeriodString(recurringFrequency, recurringPeriod) {
        if (recurringPeriod == null)
            return "";
            
        console.assert(recurringPeriod == "days" || recurringPeriod == "months" || recurringPeriod == "years");
        if ( recurringPeriod == "months" && recurringFrequency == 12) {
            recurringPeriod = "years";
            recurringFrequency = 1;
        }

        if ( recurringFrequency > 1)
            return Localizer.format( recurringPeriod == "days" ? Localizer.keys.dayPlural 
                : recurringPeriod == "months" ? Localizer.keys.monthPlural : Localizer.keys.yearPlural, [recurringFrequency] );
        else 
            return Localizer.format( recurringPeriod == "days" ? Localizer.keys.prefixDaySingle 
                : recurringPeriod == "months" ? Localizer.keys.prefixMonthSingle : Localizer.keys.prefixYearSingle);
    },

    renewPeriodOfUpdates(state) {
        var guid = this.renewLicenseGuid(state);
        if ( guid == null)
            return "";
        var product = this._guidToProduct(guid, state);
        if ( product == null)
            return "";
        return Localizer.format(Localizer.keys.oneYearOfUpdates,[ this.prefixPeriodString(product.recurringFrequency, product.recurringPeriod) ]);
    },

    upgradePeriodOfUpdates(state) {
        var upgrade = [];
        var isHm3 = state.header == HeaderType.Hm3;
        if ( isHm3)
            upgrade = ProductGuids.buyHm3Guid;
        else 
            upgrade = ProductGuids.buyOmahaGuid;

        var guid = null;
        if ( upgrade.length > 0) {
            var guids = this._productGuidListToAvailableGuidList(upgrade, state);
            if ( guids.length > 0)
                guid = guids[0];
        }
        if ( guid != null) {
            var product = this._guidToProduct(guid, state);
            if ( product != null)
                return Localizer.format(Localizer.keys.removesRestrictions3,[ this.prefixPeriodString(product.recurringFrequency, product.recurringPeriod) ]);
        }

        return "";
    },




};



// WEBPACK FOOTER //
// ./src/state/pricing.js